import { motion } from 'framer-motion';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const CompanyHistoryProfilePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="inline-block mb-6 px-5 py-2 border border-red/20 bg-red/5 rounded-full">
                <span className="text-red text-sm font-medium">会社の沿革</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                会社の沿革、経営者のプロフィールは重要
              </h1>
            </motion.div>
          </div>
        </section>

        {/* Article Content */}
        <article className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="prose prose-lg max-w-none"
            >
              <div className="space-y-8 text-gray-700 leading-relaxed text-[17px]">
                <p>
                  仕事をするときに、過去になにをしてきたか重要と思います。
                </p>

                <p>
                  会社や経営者は、過去にやってきたことと行動の癖のようなものがあります。
                </p>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">信頼性を見極めるポイント</h2>
                  <p className="mb-4">
                    その人がどのようなことをしてきたか、以下の情報から確認できます:
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-red rounded-full mt-2 flex-shrink-0"></div>
                      <span>会社のパンフレットなどの会社の沿革</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-red rounded-full mt-2 flex-shrink-0"></div>
                      <span>経営者のプロフィール</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-red rounded-full mt-2 flex-shrink-0"></div>
                      <span>ネット等でどのように出てくるか</span>
                    </li>
                  </ul>
                </div>

                <p>
                  そこからなんとなく垣間見えることもあります。仕事をするうえで信用できるか、キチンとお金を払うか、法律を守る意志があるか、時間を守るか、人間関係でトラブルを起こさないか、などなど。
                </p>

                <p>
                  過去にやってきたことが、形を繰り返して表れてくるような気がします。
                </p>

                <div className="bg-white rounded-2xl p-8 border-l-4 border-red shadow-sm my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">会計士の視点から</h2>
                  <p className="mb-4">
                    わたしの場合、帳簿を見て届出などを調査し、過去の税務調査のことについてきくことが多いですが、そこにも会社の性格、経営者の性格があらわれているような気がします。
                  </p>
                  <div className="space-y-4 mt-6">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">帳簿が正しくきっちりしている</strong>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-question-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">よくわからない数字がある</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">お金の使い方に現れる経営者の性格</h2>
                
                <div className="grid md:grid-cols-2 gap-4 my-8">
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-building-line text-red"></i>
                      </div>
                      <span className="font-medium text-gray-900">事務所をどんどん増やす</span>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-team-line text-red"></i>
                      </div>
                      <span className="font-medium text-gray-900">従業員の給料をどんどん上げる</span>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-restaurant-line text-red"></i>
                      </div>
                      <span className="font-medium text-gray-900">接待交際をよくする</span>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-bank-line text-red"></i>
                      </div>
                      <span className="font-medium text-gray-900">借り入れをドンドン増やす</span>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-car-line text-red"></i>
                      </div>
                      <span className="font-medium text-gray-900">高級車を買う</span>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-ship-line text-red"></i>
                      </div>
                      <span className="font-medium text-gray-900">ヨットやヘリを買う等々</span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-lightbulb-line text-red text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3">金融機関の視点</h3>
                      <p>
                        なお銀行の事業計画書でも経営者の経歴を書く欄があり、金融機関はやっぱりしっかりしているなと思います。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-8 mt-12">
                  <p className="text-gray-600">
                    過去の実績や行動パターンは、将来の信頼性を判断する重要な指標となります。会社の沿革や経営者のプロフィールをしっかりと確認することで、より良いビジネスパートナーシップを築くことができるでしょう。
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </article>

        {/* Related Articles */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">関連記事</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <a
                href="/blog/business-planning"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/business-planning');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/c07efca2585f4794a7011465253b7173.jpg"
                    alt="事業計画"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    事業計画
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    事業計画をつくるのはこんな感じです
                  </h3>
                </div>
              </a>

              <a
                href="/blog/multiple-income"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/multiple-income');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=multiple%20income%20streams%20concept%20with%20financial%20documents%20and%20calculator%2C%20organized%20tax%20preparation%20materials%20on%20modern%20desk%2C%20professional%20accounting%20workspace%20with%20clean%20aesthetic%2C%20business%20photography%20emphasizing%20financial%20management&width=800&height=500&seq=blog-003&orientation=landscape"
                    alt="確定申告"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    確定申告
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    複数の収入をもつ
                  </h3>
                </div>
              </a>

              <a
                href="/blog/cash-register-management"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/cash-register-management');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20cash%20register%20and%20financial%20management%20system%20in%20retail%20setting%2C%20organized%20point%20of%20sale%20workspace%20with%20clean%20professional%20aesthetic%2C%20business%20technology%20with%20natural%20lighting%2C%20commercial%20photography%20emphasizing%20efficiency%20and%20accuracy&width=800&height=500&seq=blog-004&orientation=landscape"
                    alt="現金管理"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    現金管理
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    レジ現金管理
                  </h3>
                </div>
              </a>

              <a
                href="/blog/depreciation"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/depreciation');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=depreciation%20concept%20with%20business%20assets%20and%20financial%20calculations%2C%20professional%20accounting%20documents%20on%20modern%20desk%2C%20clean%20office%20environment%20with%20natural%20lighting%2C%20business%20photography%20emphasizing%20financial%20planning%20and%20asset%20management&width=800&height=500&seq=blog-005&orientation=landscape"
                    alt="減価償却"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    税務
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    減価償却
                  </h3>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-red-dark to-red">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold text-white mb-6">
                経営のお悩み、お気軽にご相談ください
              </h2>
              <p className="text-white/90 mb-10 text-lg leading-relaxed">
                会計・税務の専門家として、あなたのビジネスをサポートします。<br />
                まずは無料相談で、お気軽にご相談ください。
              </p>
              <a
                href="/#contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
                className="inline-block bg-white text-red px-12 py-4 rounded-full text-[15px] font-medium hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                無料相談を予約する
              </a>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CompanyHistoryProfilePage;
